import CreateBulkEntities from '../CreateBulkEntities'

const CreateBulkTerminal = () => {
  return <CreateBulkEntities type="bulkTerminal" />
}
export default CreateBulkTerminal
